import {
  Component,
  ElementRef,
  afterNextRender,
  contentChildren,
  input,
  viewChild,
} from '@angular/core';
import { DisclaimerSlideDirective } from '../directives/disclaimer-slide.directive.ts';
import { SwiperContainer } from 'swiper/element';

@Component({
  selector: 'liberro-disclaimer-carousel',
  standalone: false,
  templateUrl: './disclaimer-carousel.component.html',
  styleUrl: './disclaimer-carousel.component.less',
})
export class DisclaimerCarouselComponent {
  public readonly slides = contentChildren(DisclaimerSlideDirective, { descendants: true });

  public detailView = input<boolean>(false);
  private readonly swiperEl = viewChild.required<ElementRef<HTMLElement>>('swiperEl');
  private readonly prevEl = viewChild.required<ElementRef<HTMLElement>>('prevEl');
  private readonly nextEl = viewChild.required<ElementRef<HTMLElement>>('nextEl');
  private readonly paginationEl = viewChild.required<ElementRef<HTMLElement>>('paginationEl');

  public constructor() {
    afterNextRender(() => {
      const el = this.swiperEl().nativeElement as SwiperContainer;

      Object.assign(el, {
        navigation: {
          prevEl: this.prevEl().nativeElement,
          nextEl: this.nextEl().nativeElement,
          addIcons: false,
        },
        pagination: {
          el: this.paginationEl().nativeElement,
          clickable: true,
        },
        mousewheel: { forceToAxis: true },
      });

      el.initialize();
    });
  }
}